import { ArrowRight01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { ReactElement, useState } from "react";
import { Box, Button, Paper, Stack, Step, StepContent, StepLabel, Stepper, Typography } from "@mui/material";
import DomainVerification from "./components/DomainVerification";
import React from "react";
interface Step {
    label: string;
    description: string;
    component: ReactElement;
    hidden: boolean;
}

const steps: Step[] = [
  {
    label: 'Registrate como propietario',
    description: 'Antes de registrar tu sitio en Google debes demostrar que es de tu propiedad ó que eres quien lo administra. Para lograrlo deberás seguir estos dos pasos:',
    component: <DomainVerification/>,
    hidden: false,
  },
  {
    label: 'Registra el sitio web',
    description: 'Para aparecer en los resultados de búsqueda debes solicitar al buscador que indexe tu sitio',
    component: <DomainVerification/>,
    hidden: true,
  },
  {
    label: 'Seguimiento',
    description: 'Entérate que esta pasando entu sitio web analizando las estadísticas avanzadas de Google Analytics',
    component: <DomainVerification/>,
    hidden: true,
  },
];

const GoogleTools = () => {
    const [activeStep, setActiveStep] = useState(0);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return (
        <Paper sx={{ padding: 2, paddingBottom: 4 }}>
            <Stack gap={2}>
                <Typography variant="h4">Conectar con Google</Typography>
                <Stepper activeStep={activeStep} orientation="vertical">
                    {steps.filter(step => !step.hidden).map((step, index) => (
                        <Step key={step.label}>
                            <StepLabel
                                optional={
                                    index === steps.length - 1 ? (
                                    <Typography variant="caption">Last step</Typography>
                                    ) : null
                                }
                            >
                                {step.label}
                            </StepLabel>
                            <StepContent>
                                <Stack gap={2}>
                                    <Typography>{step.description}</Typography>

                                    {React.cloneElement(step.component, {})}

                                    {steps.filter(step => !step.hidden).length - 1 !== index ? (
                                        <Box sx={{ mb: 2 }}>
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                disabled={index === 0}
                                                onClick={handleBack}
                                                sx={{ mt: 1, mr: 1 }}
                                            >
                                                Atras
                                            </Button>
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                onClick={handleNext}
                                                sx={{ mt: 1, mr: 1, px: 2 }}
                                                endIcon={<HugeiconsIcon icon={ArrowRight01Icon} />}
                                            >
                                                {index === steps.length - 1 ? 'Finalizar' : 'Continuar'}
                                            </Button>
                                        </Box>
                                    ) : null}
                                </Stack>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
                {activeStep === steps.length && (
                    <Paper square elevation={0} sx={{ p: 3 }}>
                        <Typography>All steps completed - you&apos;re finished</Typography>
                        <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
                            Reset
                        </Button>
                    </Paper>
                )}
            </Stack>
        </Paper>
    )
}

export default GoogleTools;
